<div class="layoutBlock detailpage">
    <div class="detailpageSideLeft">
        <div style="float: right;">
            <div class="circle-icon">
                <div>
                    <img hisImage="job" class="inlineicon" title="{{'rm.erp.jobadvertisement' | hisUi}}">
                </div>
            </div>
        </div>
    </div>
    <div class="detailpageCenter">
        <his-dialog-header [showSaveButton]="false" [showResetButton]="false" [showSearchButton]="false">
            <ng-container customButtons>
                <his-display-webshare [btnTitle]="'rm.erp.jobadvertisement.webshare.tooltip'"
                    [title]="jobad.shortDescription ?? ''" [text]="jobad.shortDescription ?? ''"></his-display-webshare>
            </ng-container>
        </his-dialog-header>
        <div class="vcard">
            <div class="furtherInformations">
                <small>
                    <span>{{ jobad.jobAdvertisementCategory?.longtext }}</span>
                </small>
            </div>
            <h1>{{ jobad.shortDescription }}</h1>
            <div>
                <span *ngIf="jobad.refNumber && isRefNumberVisible">
                    {{ 'rm.erp.jobadvertisement.refnumber' | hisUi }}: {{ jobad.refNumber }}<br>
                </span>
                <span *ngIf="jobad.validTo && isValidToVisible">
                    {{ 'rm.erp.jobadvertisement.validto' | hisUi }}: {{ jobad.validTo | hisDate }}<br>
                </span>
                <ng-container *ngIf="jobad.jobAdvertisementDocumentAvailable && jobad.id">
                    <br>
                    <button (click)="downloadJobAdvertisementDocument(jobad.id)" hisImage="DOWNLOAD" class="transparent"
                        [title]="'rm.erp.jobadvertisement.button.title.download.jobadvertisement' | hisUi">{{'rm.erp.jobadvertisement.button.download.jobadvertisement'
                        | hisUi}}</button><br>
                </ng-container>
            </div>
        </div>

        <div class="description">
            <h2>{{'rm.erp.jobadvertisement.jobdescription' |
                hisUi}}</h2>
            <p [innerHTML]="jobad.description"></p>
        </div>

        <p-panel>
            <div class="layoutBlock">
                <div class="columnHalf" *ngIf="jobad.firstContactPerson">
                    <p-header>
                        <h2>{{jobad.firstContactPerson.description}}</h2>
                    </p-header>
                    <span
                        *ngIf="jobad.firstContactPerson.firstname && jobad.firstContactPerson.lastname">{{jobad.firstContactPerson.salutation}} {{jobad.firstContactPerson.firstname}}
                        {{jobad.firstContactPerson.lastname}}</span><br> <br>
                    <his-display-phone *ngIf="jobad.firstContactPerson.phone"
                        value="{{jobad.firstContactPerson.phone}}"></his-display-phone>
                    <br>
                    <his-display-email *ngIf="jobad.firstContactPerson.mail" value="{{jobad.firstContactPerson.mail}}">
                    </his-display-email>
                </div>

                <div class="columnHalf" *ngIf="jobad.secondContactPerson">
                    <p-header>
                        <h2>{{jobad.secondContactPerson.description}}</h2>
                    </p-header>
                    <span
                        *ngIf="jobad.secondContactPerson.firstname && jobad.secondContactPerson.lastname">{{jobad.secondContactPerson.salutation}} {{jobad.secondContactPerson.firstname}}
                        {{jobad.secondContactPerson.lastname}}</span><br> <br>
                    <his-display-phone *ngIf="jobad.secondContactPerson.phone"
                        value="{{jobad.secondContactPerson.phone}}"></his-display-phone>
                    <br>
                    <his-display-email *ngIf="jobad.secondContactPerson.mail"
                        value="{{jobad.secondContactPerson.mail}}"></his-display-email>
                </div>
            </div>
        </p-panel>

        <div class="layoutBlock" *ngIf="jobad.onlineApplicationPossible">
            <button (click)="openJobApplication()" hisImage="ARROW_RIGHT_FAT" class="button_highlighted_dark_green">
                {{'rm.erp.jobadvertisement.button.startApplication'| hisUi}}</button>
        </div>
    </div>
    <div class="detailpageSideRight"></div>
</div>
